<template>
    <div>
        <div class="row m-t-5">
            <div class="columns">
                <div class="row row-collapse-indent row-middle m-b-2">
                    <div class="column">
                        <h4 class="f-s-5 m-b-2">{{ heading }}</h4>
                    </div>
                    <div class="text-right p-r-4">
                        <a class="h-anim h-c-theme" href="#products">
                            {{ trans('See All') }}
                            <span class="i-container i-filled-theme">
                                <svg class="icon i-size-small" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" class="icon"/></svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <products
                v-bind:items="filteredProducts"
                v-bind:narrow="isNarrow"
                v-bind:show-toolbar="false"
                v-bind:visible-items-num="numberOfProducts"
            ></products>
        </div>
    </div>
</template>
<script>
    import Block from './Block.vue';
    import ProductsForBlock from '../../../Products.vue';

    export default {
        extends: Block,
        components: {
            'products': ProductsForBlock
        },
        data() {
            return {
                heading: _.get(this.block.data, 'heading'),
                products: _.get(this.$parent.data, 'products'),
                showAllProducts: _.get(this.block.data, 'show_all_products', '1') === '1' ? true : false,
                numberOfProducts: parseInt(_.get(this.block.data, 'number_of_products', 6), 10),
                selectedProductIds: _.get(this.block, 'data.items', []),
            }
        },
        computed: {
            filteredProducts() {
                if (this.showAllProducts) {
                    return this.products;
                } else if (this.selectedProductIds.length === 0 || this.products.length === 0) {
                    return [];
                } else {
                    return this.selectedProductIds.map(id => _.find(this.products, (item) => {
                        return item.id == id;
                    }));
                }
            },
            isNarrow() {
                return this.$parent.$options._componentTag === 'sales-page-content';
            }
        },
    }
</script>